import BreakImageUploaderAccordion from "hoc/BreakImageUploaderAccordion";

export default {
    getUniqueSectionKey: (step) => ('breaksImageSection' + step.currentResource.id),
    props: {
        headerKey: 'editbreak.section.images.heading'
    },
    custom: BreakImageUploaderAccordion
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksImageSection.js